<script setup lang="ts">
import { computed } from "vue";

import type { ChatRoomUser } from "@/Modules/Chat/Models/Domain/Chat";

import Avatar from "@/Components/Extend/TcAvatar.vue";

import { isValidString } from "@/Utils/String";
import { useI18n } from "vue-i18n";

export interface CallerHeaderProps {
  user?: ChatRoomUser;
}

const props = defineProps<CallerHeaderProps>();

const { t } = useI18n();

const avatarSrc = computed((): string | undefined =>
  isValidString(props.user?.avatar) ? props.user.avatar : undefined
);

const avatarUsername = computed((): string =>
  isValidString(props.user?.username) ? props.user.username : "TC"
);
</script>

<template>
  <div v-if="isValidString(avatarUsername)" class="caller">
    <Avatar :alt="avatarUsername" :src="avatarSrc" class="caller__avatar" />

    <div class="caller__name">
      <p class="typography-low-xl color-content-inverse">{{ avatarUsername }}</p>
      <p class="typography-low-m color-content-inverse">{{ t("chat.message.video_call.incoming") }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.caller {
  display: flex;
  align-items: center;

  &__avatar {
    @include sp.margin(r, 4);
  }
}
</style>
